export default "__VITE_ASSET__uZW2oLnH__"